import { CampaignFieldTypeEnum } from '@www/_models';
import { SerializableFormValues } from '@www-src/app/_services/offline-lead/offline-lead.model';

export function buildCampaignFormDataFromValues(formValues: SerializableFormValues): FormData {
  const formData = new FormData();

  for (const [key, field] of Object.entries(formValues)) {
    formData.append(`fields[${key}][field]`, key);

    if (
      field.type === CampaignFieldTypeEnum.AGREEMENT_COMPETITION ||
      field.type === CampaignFieldTypeEnum.AGREEMENT_MOBILE ||
      field.type === CampaignFieldTypeEnum.AGREEMENT_EMAIL ||
      field.type === CampaignFieldTypeEnum.AGREEMENT_SMS ||
      field.type === CampaignFieldTypeEnum.AGREEMENT_WHATSAPP
    ) {
      formData.append(`fields[${key}][value]`, field.value ? '1' : '0');
    } else if (field.type === CampaignFieldTypeEnum.FILE) {
      // pliki nie są obsługiwane w trybie offline
    } else if (field.type === CampaignFieldTypeEnum.MULTIPLE_CHOICE) {
      const values = (field.value ?? []) as string[];
      const otherValue = field.otherValue;
      const toAppend = otherValue
        ? [...values, otherValue].filter((v) => v !== 'wwwOtherValue')
        : values;
      toAppend.forEach((v, i) => formData.append(`fields[${key}][value][${i}]`, v));
    } else if (field.type === CampaignFieldTypeEnum.SINGLE_CHOICE) {
      formData.append(`fields[${key}][value]`, field.otherValue ?? (field.value as string) ?? '');
    } else {
      formData.append(`fields[${key}][value]`, (field.value as string) ?? '');
    }
  }

  return formData;
}
